export var DEFAULT_LINK_AS = 'span';